import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerticalShadesClosedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vertical_shades_closed"}/>
}
